import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';
import SubjectCard from '../components/SubjectCard';

export default function Dashboard({ user, theme, onThemeToggle }) {
  const [subjects, setSubjects] = useState([]);
  const [newName, setNewName] = useState('');
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [error, setError] = useState('');

  const BACKEND_URL = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');

  const fetchSubjects = useCallback(async () => {
    try {
      const res = await api.get('/subjects');
      setSubjects(res.data);
    } catch (err) {
      console.error('Fetch subjects error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSubjects();
  }, [fetchSubjects]);

  const handleAdd = async (e) => {
    e.preventDefault();
    const name = newName.trim();
    if (!name) return;
    setAdding(true);
    setError('');
    try {
      const res = await api.post('/subjects', { name });
      setSubjects((prev) => [...prev, res.data]);
      setNewName('');
    } catch (err) {
      setError('Nem sikerült felvenni a tárgyat.');
      console.error('Add subject error:', err);
    } finally {
      setAdding(false);
    }
  };

  const handleUpdate = (updated) => {
    setSubjects((prev) =>
      prev.map((s) => (s.id === updated.id ? updated : s))
    );
  };

  const handleDelete = (id) => {
    setSubjects((prev) => prev.filter((s) => s.id !== id));
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = `${BACKEND_URL}/logout`;
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="dashboard-title">
          <span className="dashboard-icon">🎓</span>
          <h1>UniTracker</h1>
        </div>
        <div className="dashboard-user">
          <span className="user-name">{user?.name || user?.email}</span>
          <button
            className="theme-btn"
            onClick={onThemeToggle}
            title={theme === 'dark' ? 'Világos téma' : 'Sötét téma'}
            aria-label={theme === 'dark' ? 'Világos téma' : 'Sötét téma'}
          >
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          <button className="logout-btn" onClick={handleLogout}>
            Kilépés
          </button>
        </div>
      </header>

      <main className="dashboard-main">
        <section className="add-section">
          <form onSubmit={handleAdd} className="add-form">
            <input
              type="text"
              className="add-input"
              placeholder="Tárgy neve (pl. Matematika)"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              maxLength={100}
              disabled={adding}
            />
            <button
              type="submit"
              className="add-btn"
              disabled={adding || !newName.trim()}
            >
              {adding ? '...' : '+ Tárgy'}
            </button>
          </form>
          {error && <p className="form-error">{error}</p>}
        </section>

        {loading ? (
          <div className="loading">Betöltés...</div>
        ) : subjects.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">📚</span>
            <p>Még nincs felvett tárgy.</p>
            <p className="empty-hint">Adj hozzá egyet a fenti mezővel!</p>
          </div>
        ) : (
          <div className="subjects-grid">
            {subjects.map((subject) => (
              <SubjectCard
                key={subject.id}
                subject={subject}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
              />
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
